import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const GenericDatePicker = ({
  label = "Select Date",
  value,
  onChange,
  required = false,
  error = false,
  helperText = "",
  sx = {},
  slotProps = {},
  ...props
}) => (
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label={label}
      value={value}
      onChange={onChange}
      format="DD-MMM-YYYY"
      slotProps={{
        textField: {
          placeholder: "DD-MMM-YYYY", 
          size: "small",
          margin: "dense",
          required,
          fullWidth: true,
          error,
          helperText,
          sx: {
            backgroundColor: "white",
            "& .MuiFormLabel-asterisk": { color: "red" },
            ...sx,
          },
          ...slotProps.textField,
        },
        ...slotProps,
      }}
      {...props}
    />
  </LocalizationProvider>
);

export default GenericDatePicker;
